/* eslint-disable global-require */
export const translationResources = {
  'en-US': {
    translation: require('@percent/partner-dashboard/i18n/data/en/en.json')
  },
  'en-GB': {
    translation: require('@percent/partner-dashboard/i18n/data/en/en.json')
  }
}
